// Top NBA players — 2024-25 season stars
// nbaId = official NBA player ID used in CDN headshot URLs
// cdn.nba.com/headshots/nba/latest/1040x760/${nbaId}.png

export const TOP_NBA_PLAYERS = [
  { name: 'Shai Gilgeous-Alexander', nbaId: 1628983, team: 'OKC Thunder',           position: 'G' },
  { name: 'Nikola Jokić',            nbaId: 203999,  team: 'Denver Nuggets',         position: 'C' },
  { name: 'LeBron James',            nbaId: 2544,    team: 'Los Angeles Lakers',     position: 'F' },
  { name: 'Giannis Antetokounmpo',   nbaId: 203507,  team: 'Milwaukee Bucks',        position: 'F' },
  { name: 'Luka Dončić',             nbaId: 1629029, team: 'Los Angeles Lakers',     position: 'G' },
  { name: 'Jayson Tatum',            nbaId: 1628369, team: 'Boston Celtics',         position: 'F' },
  { name: 'Anthony Edwards',         nbaId: 1630162, team: 'Minnesota Timberwolves', position: 'G' },
  { name: 'Stephen Curry',           nbaId: 201939,  team: 'Golden State Warriors',  position: 'G' },
  { name: 'Kevin Durant',            nbaId: 201142,  team: 'Phoenix Suns',           position: 'F' },
  { name: 'Victor Wembanyama',       nbaId: 1641705, team: 'San Antonio Spurs',      position: 'C' },
  { name: 'Joel Embiid',             nbaId: 203954,  team: 'Philadelphia 76ers',     position: 'C' },
  { name: 'Donovan Mitchell',        nbaId: 1628378, team: 'Cleveland Cavaliers',    position: 'G' },
  { name: 'Devin Booker',            nbaId: 1626164, team: 'Phoenix Suns',           position: 'G' },
  { name: 'Damian Lillard',          nbaId: 203081,  team: 'Milwaukee Bucks',        position: 'G' },
  { name: 'Bam Adebayo',             nbaId: 1628389, team: 'Miami Heat',             position: 'C' },
  { name: 'Tyrese Haliburton',       nbaId: 1630169, team: 'Indiana Pacers',         position: 'G' },
  { name: 'Karl-Anthony Towns',      nbaId: 1626157, team: 'New York Knicks',        position: 'C' },
  { name: 'Ja Morant',               nbaId: 1629630, team: 'Memphis Grizzlies',      position: 'G' },
  { name: 'De\'Aaron Fox',           nbaId: 1628368, team: 'San Antonio Spurs',      position: 'G' },
  { name: 'Cade Cunningham',         nbaId: 1630595, team: 'Detroit Pistons',        position: 'G' },
  { name: 'Anthony Davis',           nbaId: 203076,  team: 'Los Angeles Lakers',     position: 'C' },
  { name: 'Trae Young',              nbaId: 1629027, team: 'Atlanta Hawks',          position: 'G' },
  { name: 'Kawhi Leonard',           nbaId: 202695,  team: 'LA Clippers',            position: 'F' },
  { name: 'James Harden',            nbaId: 201935,  team: 'LA Clippers',            position: 'G' },
];

// Supplemental name → NBA ID map for Stats headshot lookup
// (players.json is missing many current players)
export const PLAYER_NBA_ID_MAP = {
  'LeBron James':             2544,
  'Anthony Edwards':          1630162,
  'Victor Wembanyama':        1641705,
  'Tyrese Haliburton':        1630169,
  'Cade Cunningham':          1630595,
  "De'Aaron Fox":             1628368,
  'Bam Adebayo':              1628389,
  'Donovan Mitchell':         1628378,
  'Trae Young':               1629027,
  'Shai Gilgeous-Alexander':  1628983,
  'Nikola Jokic':             203999,
  'Nikola Jokić':             203999,
  'Giannis Antetokounmpo':    203507,
  'Luka Doncic':              1629029,
  'Luka Dončić':              1629029,
  'Jayson Tatum':             1628369,
  'Stephen Curry':            201939,
  'Kevin Durant':             201142,
  'Joel Embiid':              203954,
  'Devin Booker':             1626164,
  'Damian Lillard':           203081,
  'Ja Morant':                1629630,
  'Kawhi Leonard':            202695,
  'Karl-Anthony Towns':       1626157,
  'Anthony Davis':            203076,
  'James Harden':             201935,
  'Zion Williamson':          1629627,
  'Jaylen Brown':             1627759,
  'Darius Garland':           1629636,
  'Evan Mobley':              1630596,
  'Paolo Banchero':           1631094,
  'Franz Wagner':             1630532,
};
